export default __webpack_public_path__ + "static/media/suit.90776f67.svg";